import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { WorkspaceMemberRole } from '@workspace/domain/workspace/vo/WorkspaceMemberRole';
import { RoleMemberList } from './RoleMemberList';
import { WorkspaceMemberEditModal } from '../WorkspaceMemberEditModal';
import type { WorkspaceEntity } from '@workspace/domain/workspace';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCog } from '@fortawesome/free-solid-svg-icons';
import { useWorkspaceMemberRoles } from '@workspace/domain/workspace/useWorkspaceMemberRoles';

type Props = {
  workspace: WorkspaceEntity;
  isEditable: boolean;
};

export const MemberSummary: React.FC<Props> = ({ workspace, isEditable }: Props) => {
  const { t } = useTranslation();
  const memberRoles = useWorkspaceMemberRoles(workspace.id);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [memberEditModalOpen, setMemberEditModalOpen] = useState<boolean>(false);

  const handleIconClick = () => {
    setMemberEditModalOpen(true);
  };

  const handleListButtonClick = () => {
    setIsOpen(!isOpen);
  };

  // メンバーロール情報が取得できない場合には何も描画しない
  if (!memberRoles) return null;

  return (
    <div className="flex w-full flex-col">
      <div className="mb-1 flex flex-row items-center justify-between border-b border-gray-500">
        <div className="text-2xl font-bold">{t('workspace.memberSummary.title', { count: memberRoles.length })}</div>
        <div className="flex flex-row">
          {isEditable && (
            <span className="mx-2 block size-4 cursor-pointer" onClick={handleIconClick}>
              <FontAwesomeIcon icon={faCog} className="text-lg" />
            </span>
          )}
        </div>
      </div>
      {memberRoles.length <= 5 || isOpen ? (
        <div>
          <div className="flex flex-col">
            {WorkspaceMemberRole.values().map((role) => {
              return (
                memberRoles.hasMembersOf(role) && <RoleMemberList key={role} role={role} memberRoles={memberRoles} />
              );
            })}
          </div>
          {memberRoles.length > 5 && (
            <div className="cursor-pointer pt-1 text-center text-brand" onClick={handleListButtonClick}>
              {t('workspace.memberSummary.showLess')}
            </div>
          )}
        </div>
      ) : (
        <div>
          <div className="flex h-48 flex-col overflow-hidden">
            {WorkspaceMemberRole.values().map((role) => {
              return (
                memberRoles.hasMembersOf(role) && <RoleMemberList key={role} role={role} memberRoles={memberRoles} />
              );
            })}
          </div>
          <div className="cursor-pointer pt-1 text-center text-brand" onClick={handleListButtonClick}>
            {t('workspace.memberSummary.showMore')}
          </div>
        </div>
      )}

      {memberEditModalOpen && (
        <WorkspaceMemberEditModal
          isOpen={memberEditModalOpen}
          onClose={() => setMemberEditModalOpen(false)}
          workspace={workspace}
          memberRoles={memberRoles}
        />
      )}
    </div>
  );
};
